import { render, staticRenderFns } from "./UiHandsontable.vue?vue&type=template&id=389c38d8&scoped=true&"
import script from "./UiHandsontable.vue?vue&type=script&lang=ts&"
export * from "./UiHandsontable.vue?vue&type=script&lang=ts&"
import style0 from "./UiHandsontable.vue?vue&type=style&index=0&id=389c38d8&scoped=true&lang=css&"
import style1 from "./UiHandsontable.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c38d8",
  null
  
)

export default component.exports